import { Create, DateTimeInput, required, SimpleForm, TextInput } from 'react-admin';

export const NotificationCreate = () => {
  // Transform function to convert scheduled_at to UTC before submission
  const transform = (data: any) => {
    // Make a copy of the data to avoid mutating the original
    const transformedData = { ...data };

    // Convert scheduled_at to UTC if it exists
    if (transformedData.scheduled_at) {
      const date = new Date(transformedData.scheduled_at);
      transformedData.scheduled_at = date.toISOString();
    }

    return transformedData;
  };

  return (
    <Create redirect="list" transform={transform}>
      <SimpleForm>
        <TextInput source="title" validate={[required()]} fullWidth />
        <TextInput source="text" validate={[required()]} multiline fullWidth />
        <DateTimeInput source="scheduled_at" />
      </SimpleForm>
    </Create>
  );
};

export default NotificationCreate;
